<script>
  import Header from '../components/Header.svelte';
  import rooms from '../rooms.js';

  const theme = rooms['public'].theme;
</script>

<style lang="postcss">
  section {
    @apply mt-10;
  }
</style>

<Header {theme} />
<main style="background: {theme.floor.background.color}">
  <div class="container mt-12 px-6">
    <h1 class="text-3xl font-bold">MingleSpace Terms and Conditions</h1>

    <section>
      <strong>1.0 - USE AT YOUR OWN RISK:</strong>
      You agree to use MINGLESPACE.CO, a service of Codepilot, Inc., at your own risk. WE ARE NOT
      RESPONSIBLE FOR ANY HARM OR HARDSHIP WHICH MAY ARISE AS A RESULT OF USING THIS SERVICE. This
      includes but is not limited to harassment, identity theft, vandalism, extortion, scams,
      bribes, fraud, financial loss, property loss, or any other issues.
    </section>

    <section>
      <strong>2.0 - RIGHT TO REVOKE:</strong>
      Codepilot reserves the right to revoke access to MingleSpace at any time for any reason with
      or without cause.
    </section>

    <section>
      <strong>3.0 - ADULTS ONLY:</strong>
      MingleSpace users must be 21 years or older. Any person younger than 21 years of age on the
      date of usage is not authorized to use our services.
    </section>

    <section>
      <strong>4.0 - REAL IDENTITIES:</strong>
      No user of MingleSpace shall under any circumstances misrepresent their identity or knowingly
      use another MingleSpace user's account. You agree to use only your real first and last names
      and to use a real, unobscured snapshot of your face as your identity while using this service.
    </section>

    <section>
      <strong>5.0 - WARRANTIES:</strong>
      Services are provided “AS IS,” without any warranties, express or implied, and you shall hold
      us harmless therefrom.
    </section>

    <section>
      <strong>6.0 - LIMITATION OF LIABILITY:</strong>
      IN NO EVENT WILL WE BE LIABLE FOR ANY INCIDENTAL, INDIRECT, SPECIAL OR CONSEQUENTIAL DAMAGES
      OF ANY KIND (INCLUDING WITHOUT LIMITATION LOSS OF PROFITS OR DATA), WHETHER OR NOT YOU HAVE
      BEEN ADVISED OF THE POSSIBILITY THEREOF, HOWEVER CAUSED; WHETHER FOR BREACH OR REPUDIATION OF
      CONTRACT, TORT, NEGLIGENCE OR OTHERWISE.
    </section>

    <section>
      <strong>7.0 - CONTROVERSIES:</strong>
      Any controversies may be submitted to a court in San Francisco, California, we both agree to
      submit the controversy to arbitration, and the decision of the arbitrator shall be final and
      binding, and the arbitrator’s order may be entered in any court of competent jurisdiction and
      enforceable thereby. The prevailing party shall have all fees and costs paid for by the other
      party, in addition to any other relief it may be awarded. We each expressly agree to the
      application of California law, without regard to its conflict of laws rules, and exclusive
      venue and jurisdiction in San Francisco, California. Service may be made by commercial courier
      with tracking capabilities (e.g., UPS). All disputes on any issues, whether known or unknown,
      must be brought within one (1) year of the incident, or they shall be deemed waived; the
      parties expressly agree to a one-year statute of limitations period.
    </section>

    <section>
      <strong>8.0 - SOLE REMEDY:</strong>
      It is intended by the parties to this Agreement that services provided by Codepilot, Inc.
      shall not subject its individual employees, contractors, officers, directors or shareholders
      to any personal legal liability or exposure for risks associated with any services/ project.
      Therefore, notwithstanding anything to the contrary contained herein, you agree that as your
      sole and exclusive remedy, any claim, demand, suit or judgment shall be asserted only as
      against Codepilot, Inc.’s corporate entity, and not against any of its individual employees,
      contractors, officers, directors or shareholders.
    </section>

    <section>
      <strong>9.0 - MISCELLANEOUS:</strong>
      If any provision of this Agreement is held to be invalid or unenforceable, the remaining
      provisions will continue without being impaired or invalidated in any way. The waiver of a
      breach of any provision of this Agreement will not operate or be interpreted as a waiver of
      other or subsequent breaches. All portions of this Agreement that by their nature should
      survive termination or expiration will survive, such as payment obligations, statutes of
      limitation, venue and jurisdiction, warranty disclaimers, and limitations of liability. We
      shall not be responsible for any failure or delay in our performance due to circumstances
      beyond our reasonable control, including but not limited to acts of God, war, terrorist
      attacks, sickness, computer viruses, equipment failure, etc. Both parties have read this
      Agreement and had the opportunity to consult with their legal advisors. It will be fairly
      interpreted according to its terms, without strict construction against either party, and
      shall supersede any other agreements dated before the date of this document, whether in
      writing, orally, or via email.
    </section>

    <br />
    <br />

    <section>
      <strong>
        <em>
          By using MINGLESPACE.CO, a service provided by Codepilot, Inc., you are agreeing to these
          terms above.
        </em>
      </strong>
    </section>
    <br />
    <br />
    <br />
    <br />
    <br />
  </div>
</main>
